// relation-pill.component.ts
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UserProfileBasicData, UserProfileRelation } from 'core-lib';
import { ButtonModule } from 'primeng/button';
import { getRelationLabel } from './relation-label.util';

@Component({
  selector: 'app-userprofile-relation-pill',
  templateUrl: './userprofile-relation-pill.component.html',
  styleUrls: ['./userprofile-relation-pill.component.scss'],
  standalone: true,
  imports: [ButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserProfileRelationPillComponent {
  @Input({ required: true }) relation!: UserProfileRelation;
  @Input({ required: true }) currentProfileId!: string;
  /** Wird gefeuert, wenn auf den Namen geklickt wird */
  @Output() profileClick = new EventEmitter<UserProfileBasicData>();


  get hasProfileClick(): boolean {
    // Angular ≥16
    if ('observed' in this.profileClick) {
      return (this.profileClick as any).observed === true;
    }
    // Fallback für <16
    return ((this.profileClick as any).observers?.length ?? 0) > 0;
  }

  // --- berechnete Helfer ---

  get isFromSide(): boolean {
    return this.relation?.from?.id === this.currentProfileId;
  }

  /** Die „andere“ Seite (kann null sein, wenn Transienten nicht geladen sind) */
  get other(): UserProfileBasicData | null | undefined {
    return this.isFromSide ? this.relation?.to : this.relation?.from;
  }

  /** Fallback-Name, falls Transienten fehlen */
  get otherFallbackId(): string {
    if (this.isFromSide) return this.relation?.to.id ?? 'unknown';
    return this.relation?.from.id ?? 'unknown';
  }

  get label(): string {
    return getRelationLabel(this.relation, this.currentProfileId);
  }



  /** Anzeige-Name (Vorname Nachname) mit Fallback auf ID */
  get otherDisplay(): string {
    const o = this.other;
    if (o) {
      const first = (o.firstname ?? '').trim();
      const last = (o.name ?? '').trim();
      const full = (first || last) ? `${first} ${last}`.trim() : '';
      if (full) return full;
      if (o.id) return `#${o.id}`;
    }
    return `#${this.otherFallbackId}`;
  }

  onClickOther(): void {
    if (this.other) {
      this.profileClick.emit(this.other);
    } else {
      // Optional: Bei fehlenden Transienten könntest du hier ein Lazy-Load oder ein anderes Event feuern
      // this.profileIdClick.emit(this.otherFallbackId);
    }
  }
}
